import React, { useState, useEffect  } from 'react';
import { Link } from 'react-router-dom';
import './Drivers.css';
import SearchBar from '../Components/search';
import Typography from '@mui/material/Typography';



const filterComps = (comps, query) => {
        if (!query.toLowerCase()) {
            return comps;
        }

        return comps.filter((comp) => {
            const compName = comp.name.toLowerCase();
            return compName.includes(query.toLowerCase());
        })
}

// If a user hasn't opted in for recuded motion, then we add the animation
    addAnimation();
  
  function addAnimation() {
      document.querySelectorAll(".scroller").forEach(scroller => {
        const inner   = scroller.querySelector(".scroller_inner");
        const titleEl = inner.querySelector(".mainPageh2");
    
        // check if the text overflows its container
        if (titleEl.scrollWidth > scroller.clientWidth) {
          // mark it for CSS margin + animation
          titleEl.classList.add("overflowing");
          scroller.setAttribute("data-animated", "true");
    
          // duplicate items for seamless scroll
          Array.from(inner.children).forEach(item => {
            const dup = item.cloneNode(true);
            dup.setAttribute("aria-hidden", "true");
            inner.appendChild(dup);
          });
        }
      });
    }

const BackSeat = (Comps) => {
    let comps = Comps['backSeatApps']
    const { search } = window.location;
    const query = new URLSearchParams(search).get('name', 'other');
    const [searchQuery, setSearchQuery] = useState(query || '');
    const filteredComps = filterComps(comps, searchQuery);

    useEffect(() => {
          addAnimation();
      }, [filteredComps]);

    return (
        <div className='mainPage'>
            <SearchBar
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}/>

            <Typography
                variant="h3"
                component="h1"
                sx={{ textAlign: 'center', mb: 2 }}
            >
               Backseat Apps
            </Typography>
                <ul className='appRows'>
                <div className = "flex-row">
                    {filteredComps?.map(comp => (
                        <li key = {comp.key}>
                            <div className ="col">
                                <figure className = "gallery__item">
                                <div className = "scroller" data-speed="fast">
                                    <div className ="scroller_inner">
                                        <h2 className="mainPageh2">{comp.name}</h2>
                                    </div>
                                </div>

                                    <Link to={comp.navLink}>
                                        <img src ={comp.appLogo} className={'gallery__img'} alt = {comp.name}></img>
                                    </Link>
                                </figure>
                            </div>
                        </li>
                    ))}
                    </div>
                </ul>
        </div>
    )
};

export default BackSeat;